import { ipcApiName } from '@kinderlabs-pos/ipc/common';

export const HAS_NO_ELECTRON = 'has_no_electron';

export const WebposError = () => new Error('WEBPOS 에서는 불가능한 기능입니다.');
export const isOnElectron = window && window[ipcApiName];
